module.exports = __webpack_public_path__ + "img/singlepep.83510cf5.svg";